import { usePaginatedQuery } from '@playbookux/playbook-web-core';
import { QUERY_ATTRIBUTES, GET_CLIPS } from './graphql';

function useClips() {
  return usePaginatedQuery(
    GET_CLIPS,
    QUERY_ATTRIBUTES,
    { dataField: 'videos' },
  );
}

export default useClips;
